import { mono } from './tokens';

export default function TasksRail({
  agentId,
  activeTask,
  queued,
  completed,
  onOpenCompleted,
  color = '#53b1fd',
}) {
  const queuedList = Array.isArray(queued) ? queued : [];
  const completedList = Array.isArray(completed)
    ? completed.filter((t) => t.agentId === agentId).slice(0, 8)
    : [];

  return (
    <div
      style={{
        flex: '0 0 260px',
        borderLeft: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      <div
        style={{
          padding: '10px 12px',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <div
          style={{
            ...mono,
            fontSize: 9,
            color: 'rgba(255,255,255,0.55)',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
          }}
        >
          Tasks
        </div>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '10px 12px',
          display: 'grid',
          gap: 12,
          alignContent: 'start',
        }}
      >
        {activeTask && activeTask.status === 'running' ? (
          <div>
            <div
              style={{
                ...mono,
                fontSize: 8,
                color: '#fbbf24',
                marginBottom: 4,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
              }}
            >
              ⚡ Active
            </div>
            <div
              style={{
                background: 'rgba(255,255,255,0.02)',
                borderLeft: `3px solid ${color}`,
                borderRadius: '0 6px 6px 0',
                padding: '8px 10px',
              }}
            >
              <div
                style={{
                  ...mono,
                  fontSize: 11,
                  color: 'white',
                  fontWeight: 500,
                  lineHeight: 1.3,
                }}
              >
                {activeTask.label}
              </div>
              <div
                style={{
                  ...mono,
                  fontSize: 9,
                  color: 'rgba(255,255,255,0.35)',
                  marginTop: 4,
                }}
              >
                Step {activeTask.steps?.length || 0}
              </div>
            </div>
          </div>
        ) : null}

        {queuedList.length > 0 ? (
          <div>
            <div
              style={{
                ...mono,
                fontSize: 8,
                color: 'rgba(255,255,255,0.45)',
                marginBottom: 4,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
              }}
            >
              📋 Queued ({queuedList.length})
            </div>
            <div style={{ display: 'grid', gap: 2 }}>
              {queuedList.map((t) => (
                <div
                  key={t.id}
                  style={{
                    ...mono,
                    fontSize: 10,
                    color: 'rgba(255,255,255,0.55)',
                    padding: '5px 8px',
                    borderRadius: 4,
                    border: '1px solid rgba(255,255,255,0.04)',
                    background: 'rgba(255,255,255,0.02)',
                  }}
                >
                  {t.label}
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <div>
          <div
            style={{
              ...mono,
              fontSize: 8,
              color: 'rgba(255,255,255,0.35)',
              marginBottom: 4,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
            }}
          >
            ✓ Completed
          </div>
          {completedList.length === 0 ? (
            <div
              style={{
                ...mono,
                fontSize: 10,
                color: 'rgba(255,255,255,0.22)',
                padding: '4px 0',
              }}
            >
              Nothing yet
            </div>
          ) : (
            <div style={{ display: 'grid', gap: 2 }}>
              {completedList.map((t) => {
                const colorForStatus =
                  t.status === 'complete'
                    ? 'rgba(255,255,255,0.55)'
                    : t.status === 'cancelled'
                      ? 'rgba(255,255,255,0.4)'
                      : '#ef4444';
                return (
                  <div
                    key={t.id}
                    onClick={() => onOpenCompleted?.(t)}
                    style={{
                      ...mono,
                      fontSize: 10,
                      color: colorForStatus,
                      padding: '5px 8px',
                      borderRadius: 4,
                      cursor: 'pointer',
                      border: '1px solid rgba(255,255,255,0.04)',
                      background: 'rgba(255,255,255,0.015)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.015)';
                    }}
                  >
                    {t.status === 'complete' ? '✓' : t.status === 'cancelled' ? '•' : '✗'} {t.label}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
